import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
  useTheme,
} from '@chakra-ui/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { InputCard } from './InputCard';
import { InputDocument } from './InputDocument';
import { InputMask } from './InputMask';
import { InputPassword } from './InputPassword';
import { InputPhone } from './InputPhone';

interface IInputProps extends Omit<ChakraInputProps, 'name'> {
  name: string;
  label?: string;
  type?: string;
  mask?: string;
  maskChar?: string;
}

export const Input: React.FC<IInputProps> = ({
  name,
  label,
  type,
  ...rest
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  switch (type) {
    case 'phone':
      return <InputPhone name={name} label={label} {...rest} />;
    case 'password':
      return <InputPassword name={name} label={label} {...rest} />;
    case 'cpf':
      return <InputDocument name={name} label={label} type={type} {...rest} />;
    case 'cnpj':
      return <InputDocument name={name} label={label} type={type} {...rest} />;
    case 'card':
      return <InputCard name={name} label={label} {...rest} />;
    case 'mask':
      return (
        <InputMask
          mask={rest.mask ?? ''}
          maskChar={rest.maskChar ?? ''}
          name={name}
          label={label}
          type={type}
          {...rest}
        />
      );
    default:
      return (
        <FormControl isInvalid={!!errors[name]}>
          {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
          <ChakraInput
            id={name}
            {...register(name)}
            {...rest}
            type={type}
            bg="white"
          />
          <FormErrorMessage>
            {errors?.[name] && (errors[name]?.message as string)}
          </FormErrorMessage>
        </FormControl>
      );
  }
};
